import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OpRolesService } from 'src/app/views/common/services/op-roles.service';
import { RolesModels } from 'src/app/views/common/models/roles-models';
import { OpUsersService } from 'src/app/views/common/services/op-users.service';
import { module_names } from './ModuleNamesInDB';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: RouteInfo[] = [];
  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private roleServ: OpRolesService,
    private userService: OpUsersService
  ) { }

  // End open close
  ngOnInit() {
    this.sidebarnavItems = this.userService.getUserRolesNPermissionFormMenu();
    // console.log(this.sidebarnavItems)
  }
}
